import React from "react";
import { mergeLeft } from "ramda";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import ToolProvider from "./ToolProvider";
import Tool from "./Tool";

const elementsOptions = {
  mode: 'payment',
  currency: 'usd',
};

const DonationTool = (props) => {
  const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY, {
    stripeAccount: props.nonprofit.paymentAccountId,
    apiVersion: import.meta.env.VITE_STRIPE_API_VERSION,
  });

  return (
    <Elements stripe={stripePromise} options={mergeLeft({ amount: props.bootstrap.donationLevel?.price || 2500 }, elementsOptions)}>
      <ToolProvider bootstrap={props.bootstrap} expired={props.expired}>
        <Tool {...props} />
      </ToolProvider>
    </Elements>
  );
}

export default DonationTool;
